/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function Show(props: CustomSvgIcon) {
    const {
        className,
        id,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg
                height='24'
                width='24'
                xmlns='http://www.w3.org/2000/svg'
            >
                <g
                    fill={iconColor || '#000'}
                    id='svg_7'
                    stroke='null'
                    transform='matrix(0.8850745052957713,0,0,0.8461365915519635,2.3468365485160634,5.591931968044019)'
                >
                    <g
                        id='svg_8'
                        stroke='null'
                    >
                        <g
                            id='svg_10'
                            stroke='null'
                        >
                            <path
                                d='m10.908893,16.049365c-6.5,0 -11.78,-6.56 -12.77,-7.87a1,1 0 0 1 0,-1.22c0.99,-1.34 6.26,-7.91 12.77,-7.91s11.8,6.57 12.79,7.89l0.05,0.07a1,1 0 0 1 0,1.09c-1.04,1.39 -6.31,7.95 -12.84,7.95zm0,-16c-6,0 -11,6.24 -12,7.49c1,1.28 6,7.51 12,7.51s11,-6.23 12,-7.48l0,0l0,0c-0.95,-1.28 -5.94,-7.52 -12,-7.52z'
                                id='svg_12'
                                stroke='null'
                            />
                        </g>
                        <g
                            id='svg_9'
                            stroke='null'
                        >
                            <path
                                d='m10.908893,13.559365a6,6 0 1 1 6,-6a6,6 0 0 1 -6,6zm0,-11a5,5 0 1 0 5,5a5,5 0 0 0 -5,-5z'
                                id='svg_13'
                                stroke='null'
                            />
                        </g>
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}